/* ==========================================================================
   Maqtub — theme.js (Shopify OS 2.0 theme)
   Vanilla JS, no dependencies. Behaviour hangs off data-attributes.
   Cart:   Ajax API (/cart/add.js, /cart/change.js) + Section Rendering API
           to re-render the bag drawer (sections/cart-drawer.liquid).
   Search: Predictive Search API (/search/suggest.json).
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var icon = function (name, cls) {
    return '<svg class="icon ' + (cls || '') + '" aria-hidden="true"><use href="#i-' + name + '"></use></svg>';
  };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };
  var theme = window.theme || { routes: {} };
  var routes = theme.routes;

  /* Shopify money formatting (cents -> shop money format) */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '₹{{amount}}';
    var n = parseInt(cents, 10) || 0;
    function withDelims(num, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands; decimal = decimal == null ? '.' : decimal;
      var parts = (num / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts.join(precision ? decimal : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = withDelims(n, 0); break;
      case 'amount_with_comma_separator': value = withDelims(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(n, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(n, 2, "'", '.'); break;
      default: value = withDelims(n, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }


  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = icon('check-circle', 'icon--18') + '<span>' + esc(msg) + '</span>';
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }
  window.MaqtubToast = toast;

  /* ---------- Overlay manager (drawers, sheets, menu, search) ---------- */
  var scrim = $('[data-scrim]');
  var openStack = [];
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function setMenuTop() {
    var header = $('.site-header');
    if (header) document.documentElement.style.setProperty('--menu-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
  }

  function openOverlay(id, trigger) {
    var el = document.getElementById(id);
    if (!el || el.classList.contains('is-open')) return;
    // close siblings so only one overlay shows at a time
    openStack.slice().forEach(function (o) { closeOverlay(o.el.id, true); });
    setMenuTop();
    el.classList.add('is-open');
    el.removeAttribute('inert');
    el.setAttribute('aria-hidden', 'false');
    openStack.push({ el: el, trigger: trigger || document.activeElement });
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    if (el.hasAttribute('data-uses-scrim') && scrim) scrim.classList.add('is-open');
    document.body.classList.add('is-locked');
    var focusTarget = $('[data-autofocus]', el) || $(FOCUSABLE, el);
    setTimeout(function () { if (focusTarget) focusTarget.focus({ preventScroll: true }); }, 60);
    el.dispatchEvent(new CustomEvent('overlay:open'));
  }

  function closeOverlay(id, silent) {
    var el = document.getElementById(id);
    if (!el) return;
    var idx = -1;
    openStack.forEach(function (o, i) { if (o.el === el) idx = i; });
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('inert', '');
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (idx > -1) {
      var entry = openStack.splice(idx, 1)[0];
      if (!silent && entry.trigger && entry.trigger.focus) entry.trigger.focus({ preventScroll: true });
    }
    if (!openStack.length) {
      if (scrim) scrim.classList.remove('is-open');
      document.body.classList.remove('is-locked');
    }
  }
  window.MaqtubOverlay = { open: openOverlay, close: closeOverlay };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      var id = opener.getAttribute('data-open');
      var el = document.getElementById(id);
      if (el && el.classList.contains('is-open') && opener.hasAttribute('data-toggle')) closeOverlay(id);
      else openOverlay(id, opener);
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      e.preventDefault();
      var target = closer.getAttribute('data-close') || (closer.closest('.drawer, .sheet, .menu-panel, .search-panel') || {}).id;
      if (target) closeOverlay(target);
    }
  });
  if (scrim) scrim.addEventListener('click', function () { openStack.slice().forEach(function (o) { closeOverlay(o.el.id); }); });

  document.addEventListener('keydown', function (e) {
    if (!openStack.length) return;
    var top = openStack[openStack.length - 1].el;
    if (e.key === 'Escape') { closeOverlay(top.id); return; }
    if (e.key === 'Tab') {
      var f = $$(FOCUSABLE, top).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 1024) closeOverlay('menu-panel', true);
    if (window.innerWidth >= 768) closeOverlay('filter-sheet', true);
  });

  /* ---------- Header: shadow when scrolled ---------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }


  /* ---------- Cart (Shopify Ajax API + Section Rendering) ---------- */
  var drawer = $('#bag-drawer');
  var Cart = {
    sectionId: 'cart-drawer',
    request: function (url, body) {
      if (drawer) drawer.setAttribute('aria-busy', 'true');
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({ sections: Cart.sectionId, sections_url: location.pathname }, body))
      }).then(function (r) {
        return r.json().then(function (data) {
          if (drawer) drawer.removeAttribute('aria-busy');
          if (!r.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
          return data;
        });
      }, function (err) { if (drawer) drawer.removeAttribute('aria-busy'); throw err; });
    },
    add: function (formData) {
      var items = [{ id: formData.get('id'), quantity: parseInt(formData.get('quantity'), 10) || 1 }];
      var props = {};
      formData.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
      if (Object.keys(props).length) items[0].properties = props;
      return Cart.request((routes.cartAdd || '/cart/add') + '.js', { items: items }).then(Cart.render);
    },
    change: function (key, quantity) {
      return Cart.request((routes.cartChange || '/cart/change') + '.js', { id: key, quantity: quantity }).then(Cart.render);
    },
    render: function (data) {
      var html = data.sections && data.sections[Cart.sectionId];
      if (!html || !drawer) return data;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#bag-drawer');
      if (!fresh) return data;
      var active = document.activeElement;
      var keep = active && active.closest && active.closest('[data-line-stepper]');
      var keepInfo = keep ? [keep.getAttribute('data-line-stepper'), active.getAttribute('data-step')] : null;
      drawer.innerHTML = fresh.innerHTML;
      var count = parseInt(fresh.getAttribute('data-cart-count'), 10) || 0;
      drawer.setAttribute('data-cart-count', count);
      updateCount(count);
      $$('[data-stepper]', drawer).forEach(syncStepper);
      if (keepInfo) {
        var again = $('[data-line-stepper="' + keepInfo[0] + '"] ' + (keepInfo[1] ? '[data-step="' + keepInfo[1] + '"]' : 'input'), drawer);
        (again || $('[data-close]', drawer)).focus();
      }
      document.dispatchEvent(new CustomEvent('cart:change', { detail: { count: count } }));
      return data;
    }
  };
  window.MaqtubCart = Cart;

  function updateCount(count) {
    $$('[data-bag-count]').forEach(function (el) {
      var had = el.textContent;
      el.textContent = count;
      el.classList.toggle('has-items', count > 0);
      if (had !== String(count) && count > 0) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });
    $$('[data-bag-label]').forEach(function (el) { el.setAttribute('aria-label', 'Bag, ' + count + (count === 1 ? ' item' : ' items')); });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var panel = $('#bag-coupons-panel', drawer);
      var viewCoupons = e.target.closest('[data-view-coupons]');
      if (viewCoupons && panel) {
        panel.hidden = false; viewCoupons.setAttribute('aria-expanded', 'true');
        $$(':scope > *', drawer).forEach(function (child) { if (child !== panel) child.setAttribute('inert', ''); });
        $('[data-hide-coupons]', panel).focus();
      }
      if (e.target.closest('[data-hide-coupons]') && panel) {
        panel.hidden = true;
        $$(':scope > *', drawer).forEach(function (child) { child.removeAttribute('inert'); });
        var opener = $('[data-view-coupons]', drawer); opener.setAttribute('aria-expanded', 'false'); opener.focus();
      }
      var offer = e.target.closest('[data-public-coupon]');
      if (offer) {
        var couponForm = $('[data-coupon-form]', drawer);
        $('input', couponForm).value = offer.getAttribute('data-public-coupon');
        couponForm.closest('details').open = true;
        if (panel) panel.hidden = true;
        $$(':scope > *', drawer).forEach(function (child) { child.removeAttribute('inert'); });
        couponForm.requestSubmit();
      }
      var rm = e.target.closest('[data-remove]');
      if (rm) {
        var title = (rm.getAttribute('aria-label') || '').replace(/^Remove /, '');
        Cart.change(rm.getAttribute('data-remove'), 0).then(function () { toast(title + ' removed'); }, function (err) { toast(err.message); });
      }
    });
    drawer.addEventListener('stepper:change', function (e) {
      var s = e.target.closest('[data-line-stepper]');
      if (!s) return;
      clearTimeout(s.__t);
      s.__t = setTimeout(function () {
        Cart.change(s.getAttribute('data-line-stepper'), e.detail.value).catch(function (err) { toast(err.message); });
      }, 250);
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-coupon-form]');
    if (!form) return;
    e.preventDefault();
    var input = $('input', form), code = input.value.trim(), button = $('button', form);
    if (!code) { input.focus(); return; }
    button.disabled = true; button.textContent = 'Applying…';
    Cart.request((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', { discount: code }).then(function (data) {
      Cart.render(data);
      var current = $('[data-coupon-form]', drawer), message = $('[data-coupon-message]', current);
      $('input', current).value = code;
      var applied = (data.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
      message.textContent = applied ? 'Coupon applied.' : 'This code is invalid or does not apply to your bag.';
      $('input', current).focus();
    }).catch(function (err) { $('[data-coupon-message]', form).textContent = err.message; }).finally(function () {
      var current = $('[data-coupon-form]', drawer);
      if (current) { $('button', current).disabled = false; $('button', current).textContent = 'Apply'; }
    });
  });

  /* Card variants: one reusable dialog, also for dynamically loaded recommendations. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-card-options]');
    if (!trigger) return;
    e.preventDefault();
    var card = trigger.closest('.card'), source = $('select[name="id"]', card);
    if (!source) return;
    var panel = document.getElementById('quick-add-panel');
    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'quick-add-panel'; panel.className = 'quick-add';
      panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-labelledby', 'quick-add-title');
      panel.setAttribute('aria-hidden', 'true'); panel.setAttribute('inert', '');
      panel.setAttribute('data-uses-scrim', '');
      panel.innerHTML = '<div class="quick-add__head"><h2 class="h3" id="quick-add-title"></h2><button type="button" class="icon-btn" data-close="quick-add-panel" aria-label="Close variant selection">' + icon('close') + '</button></div><form id="quick-add-form" class="quick-add__form" data-product-form><label for="quick-add-variant">Choose a variant</label><div data-quick-options></div><input type="hidden" name="quantity" value="1"><button class="btn btn--primary" type="submit"><span data-label>Add to Bag</span></button><p class="form-error" data-form-error hidden role="alert"></p></form>';
      document.body.appendChild(panel);
    }
    $('#quick-add-title', panel).textContent = $('.card__title', card).textContent.trim();
    var select = source.cloneNode(true);
    select.hidden = false; select.removeAttribute('aria-label');
    select.id = 'quick-add-variant'; select.setAttribute('data-autofocus', '');
    var target = $('[data-quick-options]', panel);
    target.replaceChildren(select);
    var form = $('form', panel); form.__cardTrigger = trigger;
    var error = $('[data-form-error]', form); error.hidden = true; error.textContent = '';
    var button = $('button[type="submit"]', form);
    button.disabled = false; button.classList.remove('is-added');
    $('[data-label]', button).textContent = 'Add to Bag';
    openOverlay(panel.id, trigger);
  });

  /* ---------- Add to Bag (product forms: PDP, commerce cards) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var buttons = $$('[data-add-button], [type="submit"]', form).concat(form.id ? $$('[form="' + form.id + '"]') : []);
    var errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.hidden = true;
    buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    Cart.add(new FormData(form)).then(function () {
      buttons.forEach(function (b) {
        var label = $('[data-label]', b);
        if (label) {
          var original = label.getAttribute('data-original') || label.textContent;
          label.setAttribute('data-original', original);
          b.classList.add('is-added'); label.textContent = 'Added';
          setTimeout(function () { b.classList.remove('is-added'); label.textContent = original; }, 1400);
        }
      });
      openOverlay('bag-drawer', form.__cardTrigger || e.submitter || buttons[0]);
    }, function (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } else toast(err.message);
    }).then(function () {
      buttons.forEach(function (b) { b.removeAttribute('aria-busy'); if (!b.hasAttribute('data-sold-out')) b.disabled = false; });
    });
  });

  /* ---------- Variant picker (PDP) ---------- */
  function initVariantPicker(pdp) {
    var form = $('[data-product-form]', pdp);
    var picker = $('[data-variant-picker]', pdp);
    var jsonEl = $('[data-product-json]', pdp);
    if (!form || !jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = $('[data-variant-id]', form);
    var buttons = $$('[data-add-button]', pdp).concat($$('[data-add-button][form="' + form.id + '"]'));
    var soldOut = function (v) {
      buttons.forEach(function (b) {
        var available = v && v.available;
        b.disabled = !available;
        if (available) b.removeAttribute('data-sold-out'); else b.setAttribute('data-sold-out', '');
        var l = $('[data-label]', b); if (l) { l.textContent = !v ? 'Unavailable' : available ? 'Add to Bag' : 'Sold out'; l.removeAttribute('data-original'); }
      });
    };
    if (!picker) return;
    picker.addEventListener('change', function () {
      var selected = $$('input:checked', picker).map(function (i) { return i.value; });
      var variant = product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      })[0];
      soldOut(variant);
      if (!variant) return;
      idInput.value = variant.id;
      var price = $('[data-pdp-price]', pdp);
      if (price) {
        var html = '<span class="price' + (variant.compare_at_price > variant.price ? ' price--sale' : '') + '" data-price>' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price > variant.price) html += '<s class="price price--compare"><span class="visually-hidden">Regular price</span>' + formatMoney(variant.compare_at_price) + '</s>';
        price.innerHTML = html;
      }
      $$('[data-sticky-price]').forEach(function (el) { el.textContent = formatMoney(variant.price); });
      var badge = $('[data-pdp-badge]', pdp); if (badge && !badge.hasAttribute('data-fixed')) badge.textContent = variant.title;
      if (variant.featured_media && pdp.__goToMedia) pdp.__goToMedia(variant.featured_media.id);
      var url = new URL(location.href); url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations(scope) {
    $$('[data-recommendations]', scope).forEach(function (box) {
      if (box.__init || box.children.length || !box.getAttribute('data-url')) return;
      box.__init = true;
      fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (text) {
        var fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { box.innerHTML = fresh.innerHTML; initRails(box); }
        else { var sec = box.closest('.shopify-section'); if (sec) sec.hidden = true; }
      }).catch(function () { /* keep the section empty */ });
    });
  }

  /* ---------- Collection sort (desktop select) ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort-select]');
    if (!sel) return;
    var url = new URL(location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    location.href = url.toString();
  });

  /* ---------- Predictive search ---------- */
  var searchPanel = $('[data-predictive-search]');
  if (searchPanel) {
    var sInput = $('input[type="search"]', searchPanel);
    var results = $('[data-search-results]', searchPanel);
    var emptyS = $('[data-search-empty]', searchPanel);
    var suggest = $('[data-search-suggest]', searchPanel);
    var ctrl = null, timer = null;
    var run = function () {
      var q = sInput.value.trim();
      if (suggest) suggest.hidden = !!q;
      if (!q) { results.innerHTML = ''; emptyS.hidden = true; return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = (routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (data) {
        var hits = (data.resources && data.resources.results && data.resources.results.products) || [];
        emptyS.hidden = hits.length > 0;
        emptyS.textContent = 'No candles match “' + q + '”.';
        results.innerHTML = hits.map(function (p) {
          var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '';
          return '<a class="search-result" href="' + esc(p.url) + '"><div class="media media--square media--photo">' + img + '</div>' +
            '<span><span style="display:block;font-weight:500">' + esc(p.title) + '</span><span class="caption">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></span></a>';
        }).join('');
      }).catch(function () { /* aborted or offline */ });
    };
    sInput.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    $$('[data-suggest]', searchPanel).forEach(function (b) {
      b.addEventListener('click', function () { sInput.value = b.textContent; run(); sInput.focus(); });
    });
  }

  /* ---------- Form validation (contact forms submit natively to Shopify) ---------- */
  function initForms(scope) {
    $$('form[data-validate]', scope).forEach(function (form) {
      if (form.__init) return; form.__init = true;
      form.setAttribute('novalidate', '');
      function check(input) {
        var field = input.closest('.field'); if (!field) return true;
        var err = $('.field__error', field);
        var msg = '';
        var v = (input.value || '').trim();
        if (input.type === 'radio') return true;
        if (input.required && !v) msg = 'Please fill this in.';
        else if (v && input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) msg = 'Enter a valid email address.';
        else if (v && input.type === 'tel' && !/^[+\d][\d\s-]{7,}$/.test(v)) msg = 'Enter a valid phone number.';
        else if (v && input.type === 'number' && input.min && +v < +input.min) msg = 'Minimum is ' + input.min + '.';
        else if (v && input.type === 'date' && input.min && v < input.min) msg = 'Choose a date from ' + input.min.split('-').reverse().join('/') + '.';
        field.classList.toggle('has-error', !!msg);
        input.setAttribute('aria-invalid', msg ? 'true' : 'false');
        if (err) err.textContent = msg;
        return !msg;
      }
      $$('input[type="date"]', form).forEach(function (d) {
        var t = new Date(); t.setDate(t.getDate() + (parseInt(d.getAttribute('data-min-days'), 10) || 0));
        d.min = t.toISOString().slice(0, 10);
      });
      form.addEventListener('blur', function (e) { if (e.target.matches('.input')) check(e.target); }, true);
      form.addEventListener('input', function (e) { if (e.target.closest('.has-error')) check(e.target); });
      form.addEventListener('submit', function (e) {
        var ok = $$('.input', form).map(check).every(Boolean);
        if (!ok) { e.preventDefault(); var bad = $('[aria-invalid="true"]', form); if (bad) bad.focus(); return; }
        var btn = $('[type="submit"]', form);
        if (btn) btn.setAttribute('aria-busy', 'true');
      });
      var success = $('[data-form-success]', form);
      if (success && location.hash.replace('#', '') === form.id) setTimeout(function () { success.focus(); }, 100);
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-stepper] [data-step]');
    if (!b) return;
    var s = b.closest('[data-stepper]'); var input = $('input', s);
    var min = s.hasAttribute('data-line-stepper') ? 0 : 1;
    var v = Math.max(min, Math.min(99, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10)));
    input.value = v; syncStepper(s);
    s.dispatchEvent(new CustomEvent('stepper:change', { bubbles: true, detail: { value: v } }));
  });
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-stepper]');
    if (!s || e.target.tagName !== 'INPUT') return;
    var min = s.hasAttribute('data-line-stepper') ? 0 : 1;
    var v = Math.max(min, Math.min(99, parseInt(e.target.value, 10) || min));
    e.target.value = v; syncStepper(s);
    s.dispatchEvent(new CustomEvent('stepper:change', { bubbles: true, detail: { value: v } }));
  });
  function syncStepper(s) {
    var input = $('input', s); var dec = $('[data-step="-1"]', s);
    if (dec && !s.hasAttribute('data-line-stepper')) dec.disabled = parseInt(input.value, 10) <= 1;
  }
  $$('[data-stepper]').forEach(syncStepper);

  /* ---------- Hero slider: arrows, dots, ←/→ keys, drag/swipe; loops seamlessly; optional autoplay ---------- */
  function initCarousels(scope) { $$('[data-carousel]', scope).forEach(function (root) {
    if (root.__init) return; root.__init = true;
    var viewport = $('[data-viewport]', root);
    var track = $('[data-track]', root);
    var slides = $$('[data-slide]', root);
    var dots = $$('[data-dot]', root);
    var counter = $('[data-counter]', root);
    var live = $('[data-live]', root);
    var n = slides.length;
    if (!track || n < 2) return;

    // clones at both ends so the loop always moves forward/back one step
    var makeClone = function (s) {
      var c = s.cloneNode(true);
      c.removeAttribute('data-slide'); c.classList.add('is-clone');
      c.setAttribute('aria-hidden', 'true'); c.setAttribute('inert', '');
      $$('[id]', c).forEach(function (el) { el.removeAttribute('id'); });
      $$('h1', c).forEach(function (h) { var d = document.createElement('div'); d.className = h.className; d.innerHTML = h.innerHTML; h.replaceWith(d); });
      return c;
    };
    track.insertBefore(makeClone(slides[n - 1]), slides[0]);
    track.appendChild(makeClone(slides[0]));

    var index = parseInt(root.getAttribute('data-start'), 10) || 0; // real slide 0..n-1
    var pos = index + 1;                                             // position on the track incl. leading clone
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setX(px, animate) {
      track.classList.toggle('is-dragging', !animate);
      track.style.transform = 'translate3d(calc(' + (-pos * 100) + '% + ' + (px || 0) + 'px), 0, 0)';
    }
    function fitHeight() {
      var cur = track.children[pos];
      if (cur) viewport.style.height = cur.offsetHeight + 'px';
    }
    function sync(announce) {
      slides.forEach(function (s, k) {
        var on = k === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === index ? 'true' : 'false'); });
      if (counter) counter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
      if (live && announce) live.textContent = 'Slide ' + (index + 1) + ' of ' + n;
    }
    function go(step, toIndex) {
      if (typeof toIndex === 'number') { pos = toIndex + 1; }
      else { pos += step; }
      index = ((pos - 1) % n + n) % n;
      setX(0, !reduced);
      fitHeight();
      sync(true);
      if (reduced) settle();
      schedule(); // restart the countdown after every move, manual or automatic
    }

    // Autoplay: data-autoplay="3000" (ms). Pauses on hover, touch, keyboard focus and hidden tab.
    var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var timer = null;
    var holds = { hover: false, touch: false, focus: false };
    function paused() { return holds.hover || holds.touch || holds.focus || document.hidden; }
    function schedule() {
      clearTimeout(timer);
      if (!delay || paused()) return;
      timer = setTimeout(function () { if (!paused()) go(1); }, delay);
    }
    function hold(key, on) { holds[key] = on; schedule(); }
    if (delay) {
      root.addEventListener('mouseenter', function () { hold('hover', true); });
      root.addEventListener('mouseleave', function () { hold('hover', false); });
      root.addEventListener('focusin', function () { hold('focus', true); });
      root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) hold('focus', false); });
      root.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') hold('touch', true); });
      var release = function (e) { if (e.pointerType !== 'mouse') hold('touch', false); };
      root.addEventListener('pointerup', release);
      root.addEventListener('pointercancel', release);
      document.addEventListener('visibilitychange', schedule);
    }
    // after moving onto a clone, jump (without animation) to the real slide it mirrors
    function settle() {
      if (pos === 0 || pos === n + 1) {
        pos = pos === 0 ? n : 1;
        setX(0, false);
        void track.offsetWidth; // flush so the next move animates again
        track.classList.remove('is-dragging');
      }
    }
    root.__goToSlide = function (slideEl) { var k = slides.indexOf(slideEl); if (k > -1) go(0, k); delay = 0; clearTimeout(timer); };
    track.addEventListener('transitionend', function (e) { if (e.target === track) settle(); });

    setX(0, false); void track.offsetWidth; track.classList.remove('is-dragging');
    sync(false); fitHeight(); schedule();
    window.addEventListener('resize', fitHeight);
    window.addEventListener('load', fitHeight);
    $$('img', track).forEach(function (img) { if (!img.complete) img.addEventListener('load', fitHeight, { once: true }); });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-prev]')) go(-1);
      else if (e.target.closest('[data-next]')) go(1);
      else { var d = e.target.closest('[data-dot]'); if (d) go(0, dots.indexOf(d)); }
    });
    root.addEventListener('keydown', function (e) {
      if (e.target.matches('input, textarea')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });

    // drag / swipe: the slide follows the pointer, then snaps
    var drag = null, suppressClick = false;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      settle();
      drag = { x: e.clientX, y: e.clientY, dx: 0, t: Date.now(), locked: null, id: e.pointerId };
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (drag.locked === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        drag.locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (drag.locked === 'x') { try { viewport.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ } }
      }
      if (drag.locked !== 'x') return;
      e.preventDefault();
      drag.dx = dx;
      setX(dx, false);
    });
    function endDrag() {
      if (!drag) return;
      var d = drag; drag = null;
      if (d.locked !== 'x') return;
      suppressClick = Math.abs(d.dx) > 6;
      var w = viewport.clientWidth, v = Math.abs(d.dx) / Math.max(1, Date.now() - d.t);
      if (Math.abs(d.dx) > w * 0.18 || (v > 0.5 && Math.abs(d.dx) > 30)) go(d.dx < 0 ? 1 : -1);
      else { setX(0, true); }
    }
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('click', function (e) { if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; } }, true);
  }); }
  /* ---------- Mobile rail progress ---------- */
  function initRails(scope) { $$('[data-rail]', scope).forEach(function (rail) {
    if (rail.__init) return; rail.__init = true;
    var bar = $('[data-rail-progress] span', rail.parentNode);
    if (!bar) return;
    var update = function () {
      var max = rail.scrollWidth - rail.clientWidth;
      var ratio = rail.clientWidth / rail.scrollWidth;
      bar.style.width = Math.max(20, ratio * 100) + '%';
      var pos = max > 0 ? rail.scrollLeft / max : 0;
      bar.style.transform = 'translateX(' + (pos * (100 / Math.max(.2, ratio) - 100)) + '%)';
    };
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update); update();
  }); }
  // Arrows for desktop sliders: step one card at a time; dim at either end
  function initRailArrows(scope) { $$('.rail-wrap', scope).forEach(function (wrap) {
    var rail = $('[data-rail]', wrap), prev = $('[data-rail-prev]', wrap), next = $('[data-rail-next]', wrap);
    if (!rail || !prev || !next || wrap.__arrows) return; wrap.__arrows = true;
    var step = function () { var c = rail.children[0]; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : rail.clientWidth; };
    var sync = function () { prev.disabled = rail.scrollLeft < 4; next.disabled = rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 4; };
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true }); window.addEventListener('resize', sync); sync();
    if (wrap.hasAttribute('data-rail-autoplay') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var paused = false, lastInteraction = 0;
      ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(function (event) {
        wrap.addEventListener(event, function () { lastInteraction = Date.now(); }, { passive: true });
      });
      var autoplayTimer = setInterval(function () {
        if (!wrap.isConnected) { clearInterval(autoplayTimer); return; }
        if (paused || document.hidden || wrap.contains(document.activeElement) || Date.now() - lastInteraction < 10000) return;
        var max = rail.scrollWidth - rail.clientWidth;
        if (max < 4) return;
        rail.scrollTo({ left: rail.scrollLeft >= max - 4 ? 0 : Math.min(max, rail.scrollLeft + step()), behavior: 'smooth' });
      }, 3000);
    }

  }); }
    // Gallery: thumbs, prev/next, arrow keys, swipe (native scroll-snap)
  function initProductPage(scope) {
    var pdp = $('[data-pdp]', scope) || (scope.matches && scope.matches('[data-pdp]') ? scope : null);
    if (!pdp || pdp.__init) return; pdp.__init = true;
    var gallery = $('[data-gallery]', pdp);
    var slidesG = $$('[data-gallery] > *', pdp);
    var thumbs = $$('[data-thumb]', pdp);
    var gCounter = $('[data-gallery-counter]', pdp);
    var gi = 0;
    function setActive(i) {
      gi = i;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (gCounter) gCounter.textContent = (i + 1) + ' / ' + slidesG.length;
    }
    function goTo(i) {
      i = (i + slidesG.length) % slidesG.length;
      gallery.scrollTo({ left: slidesG[i].offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    if (gallery) {
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
      $$('[data-gallery-prev]', pdp).forEach(function (b) { b.addEventListener('click', function () { goTo(gi - 1); }); });
      $$('[data-gallery-next]', pdp).forEach(function (b) { b.addEventListener('click', function () { goTo(gi + 1); }); });
      gallery.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(gi - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(gi + 1); }
      });
      var t;
      gallery.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { setActive(Math.round(gallery.scrollLeft / gallery.clientWidth)); }, 80);
      }, { passive: true });
      setActive(0);
      pdp.__goToMedia = function (mediaId) {
        var k = slidesG.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(mediaId));
        if (k > -1) goTo(k);
      };
    }

    // Sticky mobile bar appears once the main CTA scrolls off
    var mainCta = $('[data-main-cta]', pdp);
    var sticky = $('[data-sticky-atc]');
    if (mainCta && sticky) {
      var syncSticky = function () {
        sticky.classList.toggle('is-visible', mainCta.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', syncSticky, { passive: true });
      syncSticky();
    }
    initVariantPicker(pdp);
  }
  /* ---------- Tabs (segmented control) ---------- */
  function initTabs(scope) { $$('[data-tabs]', scope).forEach(function (root) {
    if (root.__init) return; root.__init = true;
    var tabs = $$('[role="tab"]', root);
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') select(tabs[(i + 1) % tabs.length], true);
        if (e.key === 'ArrowLeft') select(tabs[(i - 1 + tabs.length) % tabs.length], true);
      });
    });
    var hash = location.hash.replace('#', '');
    if (!hash && /contact_posted=true/.test(location.search)) hash = (location.hash || '').replace('#', '');
    var initial = tabs.filter(function (t) { return t.getAttribute('data-hash') === hash; })[0];
    if (initial) select(initial);
  }); }
  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope) {
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal', scope).forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal', scope).forEach(function (el) { el.classList.add('is-in'); });
  }
  }

  /* ---------- Init + theme editor support ---------- */
  function initAll(scope) {
    scope = scope || document;
    initCarousels(scope);
    initRails(scope);
    initRailArrows(scope);
    initProductPage(scope);
    initRecommendations(scope);
    initTabs(scope);
    initForms(scope);
    initReveal(scope);
    $$('[data-stepper]', scope).forEach(syncStepper);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-slide]');
    var root = slide && slide.closest('[data-carousel]');
    if (root && root.__goToSlide) root.__goToSlide(slide);
  });
})();

/* Category dropdown on the Shop page: close on outside tap or Escape */
(function () {
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-cat-menu][open]').forEach(function (m) { if (!m.contains(e.target)) m.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-cat-menu][open]').forEach(function (m) { m.removeAttribute('open'); m.querySelector('summary').focus(); });
  });
})();

/* Pincode checker (product page): format check, blocked list, delivery estimate from Bengaluru.
   Custom element, so it starts itself on page load and when the theme editor reloads the section. */
(function () {
  if (!window.customElements || customElements.get('pincode-check')) return;
  // transit days (calendar) by pincode prefix, most specific first
  var ZONES = [
    { p: ['560'], t: [1, 2] },                                            // Bengaluru
    { p: ['56', '57', '58', '59'], t: [2, 3] },                           // rest of Karnataka
    { p: ['744', '6825', '17', '18', '19', '78', '79'], t: [6, 9] },      // Andaman, Lakshadweep, HP, J&K/Ladakh, North-East
    { p: ['50', '51', '52', '53', '60', '61', '62', '63', '64', '67', '68', '69'], t: [3, 4] }, // South India
    { p: [''], t: [4, 6] }                                                // rest of India
  ];
  function zone(pin) {
    for (var i = 0; i < ZONES.length; i++) {
      for (var j = 0; j < ZONES[i].p.length; j++) if (pin.indexOf(ZONES[i].p[j]) === 0) return ZONES[i].t;
    }
    return [4, 6];
  }
  function addBusinessDays(date, n) { // dispatch skips Sundays
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; }
    return d;
  }
  function notSunday(d) { if (d.getDay() === 0) d.setDate(d.getDate() + 1); return d; } // couriers rarely deliver on Sundays
  function fmt(d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }
  var KEY = 'maqtub:pincode';

  customElements.define('pincode-check', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      var form = this.querySelector('form'), input = this.querySelector('input'), out = this.querySelector('.pincode__result');
      var self = this;
      var blocked = (this.dataset.blocked || '').split(/[\s,]+/).filter(Boolean);
      var dMin = parseInt(this.dataset.dispatchMin, 10) || 3, dMax = parseInt(this.dataset.dispatchMax, 10) || 4;
      function show(text, state) { out.hidden = false; out.className = 'pincode__result is-' + state; out.innerHTML = text; }
      function check(pin, remember) {
        if (!/^[1-9][0-9]{5}$/.test(pin)) { show('Enter a valid 6-digit pincode.', 'error'); return; }
        if (blocked.indexOf(pin) > -1) { show('Sorry, we don’t deliver to <strong>' + pin + '</strong> yet.', 'error'); return; }
        var t = zone(pin), now = new Date();
        var from = addBusinessDays(now, dMin); from.setDate(from.getDate() + t[0]);
        var to = addBusinessDays(now, dMax); to.setDate(to.getDate() + t[1]);
        notSunday(from); notSunday(to);
        show('Delivers to <strong>' + pin + '</strong> by <strong>' + fmt(from) + ' – ' + fmt(to) + '</strong>'
          + '<span class="pincode__sub">Handmade and dispatched in ' + dMin + '–' + dMax + ' business days, then shipped from Bengaluru.</span>', 'ok');
        if (remember) { try { localStorage.setItem(KEY, pin); } catch (e) {} }
      }
      input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); });
      form.addEventListener('submit', function (e) { e.preventDefault(); check(input.value.trim(), true); });
      try { var saved = localStorage.getItem(KEY); if (saved) { input.value = saved; check(saved, false); } } catch (e) {}
      self.setAttribute('data-ready', '');
    }
  });
})();

/* Shop Candles dropdown: hover/focus open it (CSS); on touch screens the first tap opens it.
   Keeps aria-expanded in sync; Escape or a tap outside closes it. */
(function () {
  var touch = window.matchMedia('(hover: none)');
  function setOpen(drop, open) {
    drop.classList.toggle('is-open', open);
    var t = drop.querySelector('.nav-drop__toggle'); if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-nav-drop]').forEach(function (drop) {
      if (drop.__init) return; drop.__init = true;
      var toggle = drop.querySelector('.nav-drop__toggle');
      drop.addEventListener('mouseenter', function () { setOpen(drop, true); });
      drop.addEventListener('mouseleave', function () { setOpen(drop, false); });
      drop.addEventListener('focusout', function (e) { if (!drop.contains(e.relatedTarget)) setOpen(drop, false); });
      toggle.addEventListener('click', function (e) {
        if (touch.matches && !drop.classList.contains('is-open')) { e.preventDefault(); setOpen(drop, true); }
      });
    });
  }
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-nav-drop].is-open').forEach(function (d) { if (!d.contains(e.target)) setOpen(d, false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-nav-drop].is-open').forEach(function (d) { setOpen(d, false); d.querySelector('.nav-drop__toggle').focus(); });
  });
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
